import {
    Component,
    OnInit,
    Input
} from '@angular/core';

import { ApiService } from '../../core/upgraded-providers';

@Component({
    selector: 'app-transaction-user-at-room',
    templateUrl: './transaction-user-at-room.component.pug',
    styleUrls: ['./transaction-user-at-room.component.less']
})
export class TransactionUserAtRoomComponent implements OnInit {

    @Input() title;

    @Input() userId;
    @Input() room;
    @Input() shard;

    public user;

    constructor(
        private _apiService: ApiService
    ) { }

    ngOnInit() {
        if (this.userId) {
            this._apiService
                .get('user/find', { id: this.userId })
                .then(({ user }) => this.user = user);
        }
    }

}
